import { Injectable } from '@angular/core';
import { TimeoutService } from './timeout.service';

@Injectable({
  providedIn: 'root'
})
export class UserActivityService {
  private isActive = false;

  constructor(private timeoutService: TimeoutService) {}

  startTracking() {
    this.isActive = true;
    this.timeoutService.startTimeout();
    this.addEventListeners();
  }

  stopTracking() {
    this.isActive = false;
    this.removeEventListeners();
    this.timeoutService.stopTimeout();
  }

  private addEventListeners() {
    ['click', 'mousemove', 'keypress'].forEach(eventName => {
      document.addEventListener(eventName, this.resetOnActivity);
    });
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  private removeEventListeners() {
    ['click', 'mousemove', 'keypress'].forEach(eventName => {
      document.removeEventListener(eventName, this.resetOnActivity);
    });
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  private resetOnActivity = () => {
    if (this.isActive) {
      this.timeoutService.resetTimeout();
    }
  }

  private handleVisibilityChange = () => {
    if (document.hidden) {
      this.timeoutService.startTimeout();
    } else {
      this.timeoutService.resetTimeout();
    }
  }
}